import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
const TermsAndConditions = () => {
  return <div className="min-h-screen bg-white pt-16">
      <Navbar />
      
      <div className="container mx-auto py-16 px-4">
        <h1 className="text-4xl font-bold mb-8 text-center">Terms and Conditions</h1>
        
        <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-sm border border-gray-100">
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-700 mb-4">By accessing or using Talento AI's services, you agree to be bound by these Terms and Conditions. If you do not agree to all the terms and conditions, you may not access or use our services.</p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Data Collection and Usage</h2>
            <p className="text-gray-700 mb-4">When you submit your resume and personal information to Talento AI, you acknowledge and consent to:</p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Talento AI collecting, storing, and processing your personal data and resume information.</li>
              <li>Your data being used to match you with potential job opportunities within our organization or with our partner companies.</li>
              <li>Receiving communications from Talento AI regarding employment opportunities, company updates, and other relevant information.</li>
              <li>Your resume and profile information being shared with potential employers when appropriate for job matching purposes.</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Job Offers and Recruitment</h2>
            <p className="text-gray-700 mb-4">
              By submitting your information, you understand that:
            </p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>Talento AI may contact you with offers to join our organization or our partner companies.</li>
              <li>Any job offers are subject to further screening, interviews, and qualification verification.</li>
              <li>Submission of your information does not guarantee employment or an interview.</li>
              <li>Talento AI may use AI-powered tools to analyze your resume and match you with appropriate positions.</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Privacy and Data Security</h2>
            <p className="text-gray-700 mb-4">Talento AI is committed to protecting your personal information:</p>
            <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
              <li>We implement reasonable security measures to protect your personal data from unauthorized access.</li>
              <li>We retain your information only as long as necessary for the purposes outlined in these terms or as required by law.</li>
              <li>You have the right to request access to, correction of, or deletion of your personal information.</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Modifications to Terms</h2>
            <p className="text-gray-700 mb-4">Talento AI reserves the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of our services after any changes indicates your acceptance of the modified terms.</p>
          </section>
          
          <section>
            <h2 className="text-2xl font-semibold mb-4">6. Contact Information</h2>
            <p className="text-gray-700">If you have any questions about these Terms and Conditions, please contact us at legal@talento-ai.com.</p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>;
};
export default TermsAndConditions;